const generateErrorObject = (userId, errorCode, message, userMessage, filename) => {
  return {
    _id: Date.now(),
    file_type: "error",
    date: Date(),
    userId,
    errorCode,
    message,
    userMessage,
    filename
  }
}

export default generateErrorObject